import { useEffect, useState } from "react"
import { useScenario } from "../contexts/ScenarioContext"
import { MDB_TYPES } from "@meddbriefer/scenario-data/constants"
import CheckList from "./CheckList"

import Panel from "./Panel"

const PhaseCheckList = ({ section }) => {
    const [title, setTitle] = useState(null)
    const {scenario} = useScenario()
    useEffect(
        () => {
            if (MDB_TYPES.PHASE === section.type) {
                setTitle(`${section.label} checklist`)
            } else if (MDB_TYPES.SUB_PHASE === section.type) {
                const phaseTitle = scenario.getChecklistItem(section.phase).label
                setTitle(`${phaseTitle}/${section.label} checklist`)
            }
        }, [section]
    )
    if (!title) {
        return (<div>Loading...</div>)
    }
    return (
        <Panel
            title={title}
            collapsable={true}
            scrollBody={true}
            minHeight="250px"
            maxHeight="590px"
        >
        {section.items && section.items.length > 0
            ? <CheckList steps={section.items} first={true} />
            : <h6> The <b>{section.label}</b> section does not have its own checklist items. Select one of its sub-sections on the left.</h6>
        }
        </Panel>
    )

}

export default PhaseCheckList